"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M18.3 8.775c0-.34-.198-.65-.508-.789A2018.64 2018.64 0 0112.3 5.468a.735.735 0 00-.617 0c-.98.452-4.205 1.959-5.469 2.548a.891.891 0 00-.513.81v6.481c0 .292.17.558.434.682l5.456 2.536a.84.84 0 00.703.001l5.5-2.518a.872.872 0 00.509-.795V8.775H18.3zM11.95 6.496l4.546 2.07-4.548 2.068-4.465-2.07 4.467-2.068zm.528 10.787l.002-5.731 4.762-2.168-.002 5.731-4.762 2.168z" }), "Offer");
//# sourceMappingURL=Offer.js.map